// PostHog (self-hosted) - fest verdrahtet, bewusst nicht ueber die Config,
// damit alle Build-Varianten identisch senden.
//
// Bewusst OHNE posthog-js (gleiches Muster wie im gc-heizungsplaner): Die
// Instanz liefert /array/{key}/config.js mit 404, worauf weder das npm-Paket
// noch der Snippet-Loader ueberhaupt einen Capture-Request absetzen. Der
// Ingestion-Endpunkt selbst funktioniert (POST /i/v0/e/ -> {"status":"Ok"}).
// Nebeneffekt: kein externes Skript im Iframe, keine Cookies, kein Storage.
const POSTHOG_API_KEY = 'phc_wiSjn7Uu3iikMYUd2ymzapKABVWLKcHg8yKSBU24z4qJ';
const POSTHOG_HOST = 'https://analytics.ihre-fhw-seite.de';
const POSTHOG_ENDPOINT = POSTHOG_HOST + '/i/v0/e/';

// Nur im Speicher, kein Cookie und kein localStorage: pro Seitenaufruf eine
// neue anonyme ID. Der Konfigurator laeuft im Iframe auf fremden Kundenseiten.
let distinctId = null;

const getDistinctId = () => {
  if (!distinctId) {
    distinctId = 'anon-' + Math.random().toString(36).slice(2) + '-' +
        Math.random().toString(36).slice(2);
  }
  return distinctId;
};

// Traffic von Kundenseiten im selben Projekt von Testlaeufen trennbar halten.
const getEnvironment = () => {
  try {
    const host = (window.location.hostname || '').toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1' || host === '') {
      return 'local';
    }
    return 'live';
  } catch (e) {
    return 'unknown';
  }
};

// Auf welcher Kundenseite ist der Konfigurator eingebettet? Nur die Domain,
// nicht die vollstaendige URL.
const getEmbeddingDomain = () => {
  try {
    if (!document.referrer) {
      return '(direkt)';
    }
    return new URL(document.referrer).hostname;
  } catch (e) {
    return '(unbekannt)';
  }
};

let baseProperties = {};

// Einmal beim App-Start aufrufen: setzt die Basis-Properties und sendet den
// Standard-Pageview ($pageview mit $current_url, wie ihn PostHog erwartet).
export const initAnalytics = () => {
  baseProperties = {
    app: 'badkonfigurator',
    environment: getEnvironment(),
    embedding_domain: getEmbeddingDomain(),
  };
  track('$pageview', {$current_url: window.location.href});
};

export const track = (event, properties) => {
  try {
    const body = {
      api_key: POSTHOG_API_KEY,
      event: event,
      distinct_id: getDistinctId(),
      properties: Object.assign({}, baseProperties, properties || {}),
    };
    // keepalive, damit das Event auch bei einem direkt folgenden Redirect
    // (Elternseite navigiert nach dem Absenden weg) noch rausgeht.
    fetch(POSTHOG_ENDPOINT, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(function () {
      // Tracking darf den Konfigurator nie kaputtmachen
    });
  } catch (e) {
    console.log('tracking failed', e);
  }
};
